// extracted by mini-css-extract-plugin
module.exports = {"btn":"ThemeSwitcher_btn__uVxrk"};